module.exports = __webpack_public_path__ + "img/luntan_2018_06.61af7813.jpg";